export const iconFontAwesomeTravelHotelCarBurst = (
	<i className="fa-solid fa-car-burst"></i>
);
